import React, { useState, useContext, useEffect } from 'react';
import {IProps} from './types';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import * as S from './styles';
import FilterCheck from '@components/Filter';
import C from '@assets/themes/colors';
import Button from '@components/Button';
import { Context } from '@routes/private/Editor/Context';
import RadioButtonList, {RadioButtonListItem} from '@components/RadioButtonList';
import { IExportingArtboardNames, IExportingProperties, IExportingRatio } from '@routes/private/Editor/types';
import Slider from 'rc-slider';
import GalleryExport from '../GalleryExport';
import { IDSConfig } from '@state/dsconfig/types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';


const ExportOption:React.FC<IProps> = (props) => {
  const dealers = useSelector(selectors.dealers.getDealers);

  const dsConfig: IDSConfig | undefined = useSelector(selectors.dsConfig.getDSConfig);
  const { editorStatus, data, onExporting, onExportingPropsChange, onExportingCompress} = useContext(Context);
  const [exportingProperties, setExporingProperties] = useState<IExportingProperties>();  
  const [compressValues, setCompressValues] = useState<IExportingRatio[]>([])
  const [openGalleryExport, setOpenGalleryExport] = useState(false);
  
  const [compressArtboard, setCompressArtboard] = useState<string | undefined>();
  const startSlider = 0;
  const minSlider = 0;
  const maxSlider = 100;
  

  const artboards = data[0]?.children ? data[0].children.filter(e => e.type === "Artboard") : [];

  const artboardsNames = editorStatus.selectedArtboardIds?.map(a=> {    
    return artboards.find(f=>f.id == a)!.name;
  });


  
  useEffect(() => {    

        let expprop : IExportingProperties ={
          designName:props.designName,
          format:"JPEG",
          compressFiles:false,
          tranparentBackground:false,
          dealerId: "9682",
          collection: "dealer-9682",
          prefix: "Example",
          location: "DEVICE",          
        }        
        setExporingProperties(expprop)            
        if (editorStatus.exportingSizes && editorStatus.exportingSizes.length==0)
        {
          if (artboards && artboards.length>0)
            artboards.map(element=>{
              onExportingCompress(undefined,-1,element.id);          
            })
          else
            onExportingCompress(undefined,-1,undefined);
        }

        let initCompressValues: IExportingRatio[] =[];     
        if (editorStatus.exportingProperties && editorStatus.exportingProperties.compressRatios)
        initCompressValues = [...editorStatus.exportingProperties.compressRatios]      
        else
        {
          if (artboards.length>0)
          initCompressValues = artboards.map(element=>{
            return {
              id:element.id,
              ratio: -1 ,
              size:0           
            }
          })
        else
          initCompressValues = [{ratio:-1,size:0}];
        }
        setCompressValues(initCompressValues)  
       
      
  }, []);




  useEffect(()=>{    
    if (exportingProperties)
    {      
      exportingProperties.compressRatios =  compressValues
      exportingProperties.compressArtboard = compressArtboard            
      onExportingPropsChange(exportingProperties)      
    }
  },[compressValues])
  


  let pngOpt: RadioButtonListItem ={
    id:"PNG",  
    name:"PNG",
    checked: exportingProperties?.format ==="PNG",
    enable: true,


  };
  let jpgOpt: RadioButtonListItem ={
    id:"JPEG",  
    name:"JPEG",
    checked: !exportingProperties || exportingProperties?.format=== "JPEG",    
    enable: true  
  };


  let radioOptions : RadioButtonListItem[] = [pngOpt,jpgOpt]

  const exportOptions: RadioButtonListItem[] = [
    {
      id: "DEVICE",
      name: "My Device",
      checked: !exportingProperties || exportingProperties?.location=== "DEVICE",       
      enable: true,
    },
    {
      id: "GALLERY",
      name: "Media Gallery",
      checked: exportingProperties?.location === "GALLERY",
      enable: true,
    },
  ];

  const SetCompressValues = (value: number|undefined, id?:string) => {  

    let newCompressValues = [...compressValues];
    if (id)
    {
      let ratio = newCompressValues.find(f=>f.id===id);
      if (ratio)
        ratio.ratio = value??0
    }
    else
      newCompressValues[0].ratio = value??0
    setCompressValues(newCompressValues);     
    setCompressArtboard(id);    
  }

  const GetCompressValue = (id?:string) =>{    
    if (editorStatus.exportingSizes)
    {
      if (id)
      {      
        let ratio = editorStatus.exportingSizes.find(f=> f.id === id)
        if (ratio)
          return ratio?.ratio??0
      }
      else  
      {
        if (editorStatus.exportingSizes.length>0)  
          return editorStatus.exportingSizes[0].ratio??0
      }
    }
  }

  const GetCompressSize = (id?: string) =>
  {
    if (editorStatus.exportingSizes && editorStatus.exportingSizes.length>0)
    {
      let sizeval =0;
      if (id)
      {
        let size = editorStatus.exportingSizes.find(f=>f.id === id)
        sizeval = size?.size??0;
      }
      else
        sizeval=  editorStatus.exportingSizes[0].size??0

      return Math.round(sizeval / 1000).toString() + "kb"
    }
  }
  

  const handleInputSlider = (e: any, id?:string) => {
    const inputText = e.target.value;

    if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minSlider && parseFloat(inputText)>=Math.trunc(maxSlider))) {
      SetCompressValues(0, id)      
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minSlider && parseFloat(inputText)<=maxSlider) {
      SetCompressValues(inputText,id)            
    }
  }


  const updateArtboardFilesNames = () =>{
    let filesnames = editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length>0? artboardsNames: artboards.map(a=>{return a.name})
    if (exportingProperties && filesnames)
    {
      exportingProperties.artboardsNames = filesnames.map(name=>{
        return  exportingProperties?.designName.replace(' ','_')+"_"+ name.replace(' ','_')+'.'+exportingProperties?.format.toLowerCase();                
      });
      onExportingPropsChange(exportingProperties)
    }
  
  }



  const updateArtboardsExportingNames = () =>{
    
    if (exportingProperties)
    {
      let exportingNames: IExportingArtboardNames[] = [];
      if (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length>0)
      {
        exportingNames =  editorStatus.selectedArtboardIds?.map(a=> {    
          let artboard = artboards.find(f=>f.id == a);
          let filename = exportingProperties?.designName.replace(' ','_')+"_"+ artboard!.name.replace(' ','_')+'.'+exportingProperties?.format.toLowerCase();          
          return{
              id: a,
              name:filename,
              savename:filename,
              url:""              
            }
        });
      }
      else
      {
        exportingNames =  artboards.map(a=> {              
          let filename = exportingProperties?.designName.replace(' ','_')+"_"+ a.name.replace(' ','_')+'.'+exportingProperties?.format.toLowerCase();
          return{
              id: a.id,
              name:filename,
              savename:filename,
              url:""
            }
        });
      }
      exportingProperties.names = exportingNames;      
      onExportingPropsChange(exportingProperties)
    }
  
  }

  const handleExport = () => {
    if (exportingProperties?.location === "DEVICE") {
      onExporting(true, exportingProperties);
      setTimeout(() => props.setOpenOptions(false), 2000);
    } else {

      //updateArtboardFilesNames();
      updateArtboardsExportingNames();
      setOpenGalleryExport(true);
    }
  }

  const returnExportLabel = () => {
    let imagesNumber = artboards.length;
    if (imagesNumber > 1 && editorStatus.selectedArtboardIds) {
      if (editorStatus.selectedArtboardIds.length > 0) imagesNumber = editorStatus.selectedArtboardIds.length;
    }
    return imagesNumber > 1 ? `EXPORT ${imagesNumber} IMAGES` : "EXPORT 1 IMAGE";
  }

  const handleGalleryExport = (newFolder?: string) => {
    if (exportingProperties) {
      const prefix = newFolder ? `${exportingProperties.prefix ?? ""}${newFolder.trim()}/` : exportingProperties.prefix;
      onExporting(true, {...exportingProperties, prefix});
      setTimeout(() => props.setOpenOptions(false), 2000);
    }
  }

  const exportLabel = returnExportLabel();

  return (                            
      <S.Root>
        <S.titleContainer>            
              Select the format for your export                     
        </S.titleContainer>
        <S.radioContainer>
            <RadioButtonList 
                  name="rblLocations" 
                  RadioButtonListItems = {radioOptions}         
                             
                  onSelectedItem = {(selectedValue:any) => {
                    if (exportingProperties)
                    {
                      exportingProperties.format = selectedValue
                      onExportingPropsChange(exportingProperties)
                    }
                  }}                   
              />
        </S.radioContainer>       
        <S.optionContainer style={{display: exportingProperties?.format==="PNG" ? "flex" : "none"}} >
        <FilterCheck 
                  key={`transparency`}
                  label={'Transparent Background'} 
                  type="oem"                     
                  onChange={(value:any, type:string, add:boolean) => {
                    if (exportingProperties)
                    {
                      exportingProperties.tranparentBackground = add
                      onExportingPropsChange(exportingProperties)
                    }
                  }} 
                  checked={exportingProperties?.tranparentBackground}    
                  rootStyle={{"padding": "unset"}}               
                  />
          
        </S.optionContainer>
        <S.optionContainer style={{display: (exportingProperties?.format==="JPEG" || !exportingProperties) ? "flex" : "none"}}>
        <FilterCheck 
                  key={`compress`}
                  label={'Compress Files'} 
                  type="oem" 
                  onChange={(value:any, type:string, add:boolean) => {
                    if (exportingProperties)
                    {
                      exportingProperties.compressFiles = add
                      onExportingPropsChange(exportingProperties)
                    }
                  }}
                  checked={exportingProperties?.compressFiles} 
                  rootStyle={{"padding": "unset"}}                      
                  />
          </S.optionContainer>            
          <S.optionContainer style={{display: ((exportingProperties?.format==="JPEG" && exportingProperties?.compressFiles)) ? "flex" : "none"}}>      
                  <S.LabelCompress>
                    Compression Rate
                  </S.LabelCompress>
          </S.optionContainer>
          <S.CompressContainer>
            {                   
                artboards.length>0?
                  artboards?.map((element,index) =>
                    {
                      let showSlider= true;
                      if (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds?.length>0)
                          showSlider = editorStatus.selectedArtboardIds.find(f=> f == element.id) !== undefined
                      

                    return (
                      showSlider && 
                    <S.optionContainer key={`exportop${index}`} style={{display: (exportingProperties?.format==="JPEG" && exportingProperties?.compressFiles) ? "flex" : "none", flexDirection:"column"}}>
                      <S.SliderTextContainer>
                        <S.Label>
                          {element.name}
                        </S.Label>
                        <S.InputSlider
                            value={GetCompressValue(element.id)}
                            onChange={(e)=>handleInputSlider(e,element.id)}
                        ></S.InputSlider>
                      </S.SliderTextContainer>
                      <S.SliderContainer>
                      <Slider
                        min={minSlider}
                        max={maxSlider}
                        step={1}
                        startPoint={startSlider}
                        value={GetCompressValue(element.id)}
                        onChange={(e)=> {SetCompressValues(e, element.id);}}                        
                        railStyle={{
                          height:1,
                          background: "#818181"
                          
                        }}
                        handleStyle={{
                          height: 10,
                          width: 10,                
                          marginTop: -4,
                          backgroundColor: "#c4c4c4",
                          border: 0
                        }}
                        trackStyle={{
                          height:1,
                          background: "none"
                        }}
                        dotStyle={{
                          border:0,
                          height:5,
                          width:5,
                          top:-2,
                          background: "#c4c4c4"

                        }}
                        
                      />
                      </S.SliderContainer>  
                      <S.SliderTextContainer style={{justifyContent:"flex-end", marginBottom:"20px"}}>   
                        <S.LabelSize>
                        {GetCompressSize(element.id)} 
                        </S.LabelSize>        
                      </S.SliderTextContainer>                
                    </S.optionContainer>
                    )
                    }
                  )
                :
                <S.optionContainer style={{display: (exportingProperties?.format==="JPEG" && exportingProperties?.compressFiles) ? "flex" : "none", flexDirection:"column"}}>                  
                <S.SliderTextContainer>
                        <S.Label>                            
                        </S.Label>
                        <S.InputSlider
                            value={GetCompressValue()}
                            onChange={(e)=>handleInputSlider(e)}
                        ></S.InputSlider>
                      </S.SliderTextContainer>
                <S.SliderContainer>
                <Slider
                      min={minSlider}
                      max={maxSlider}
                      step={1}
                      startPoint={startSlider}
                  value={GetCompressValue()}
                  onChange={(e)=> {SetCompressValues(e);}}
                  railStyle={{
                    height:1,
                    background: "#818181"
                    
                  }}
                  handleStyle={{
                    height: 10,
                    width: 10,                
                    marginTop: -4,
                    backgroundColor: "#c4c4c4",
                    border: 0
                  }}
                  trackStyle={{
                    height:1,
                    background: "none"
                  }}
                  dotStyle={{
                    border:0,
                    height:5,
                    width:5,
                    top:-2,
                    background: "#c4c4c4"

                  }}
                  
                />
                </S.SliderContainer>
                <S.SliderTextContainer style={{justifyContent:"flex-end", marginBottom:"20px"}}>   
                        <S.LabelSize>
                        {GetCompressSize()}
                        </S.LabelSize>        
                      </S.SliderTextContainer>   
              </S.optionContainer>
            }         
          </S.CompressContainer>   
          <S.buttonContainer>
            {
              dsConfig?.editorConfig.exportToGallery &&
              <>
                <S.titleContainer>            
                  Where would you like to export to?                    
                </S.titleContainer>
                <S.radioContainer>
                  <RadioButtonList 
                    name="rblExport" 
                    RadioButtonListItems={exportOptions}
                    onSelectedItem={(selectedValue: any) =>{ 
                      if (exportingProperties)
                        {
                          exportingProperties.location = selectedValue
                          onExportingPropsChange(exportingProperties)
                        }
                      //setRadioExportOptions(selectedValue)
                    }}                   
                  />
                </S.radioContainer>
              </>
            }
            <Button 
              label={exportLabel}
              style={{
                width: "120px",
                hoverBackgroundColor: "#344a70", 
                backgroundColor: "#366cc8", 
                boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
              }} 
              onClick={handleExport}
              disabled={false}
            />                      
          </S.buttonContainer>
        {
          (openGalleryExport && exportingProperties) &&
          <GalleryExport
            exportingProperties={exportingProperties}
            setOpenGalleryExport={setOpenGalleryExport}
            onExport={handleGalleryExport}
          />
        }
      </S.Root>
  );
}

export default ExportOption;